/**
 * Block-level container element tags — insertion goes INSIDE these.
 * All other element types get the wrapper inserted AFTER them.
 */
const CONTAINER_TAGS = new Set(['DIV', 'SECTION', 'ARTICLE', 'MAIN', 'ASIDE', 'BODY']);

/**
 * Inserts a wrapper element into the DOM relative to the given anchor.
 *
 * This is the single consolidated place for inside-vs-after insertion logic.
 * No other code should make DOM insertion decisions.
 *
 * - Anchor is a block container (div, section, article, main, aside, body)
 *     → appendChild inside the anchor
 * - Anchor is anything else (script, img, span, etc.)
 *     → insertBefore after the anchor, within its parent
 *
 * @param {Element} wrapper  - the wrapper element to insert
 * @param {Element} anchor   - the resolved insertion target from resolveDefaultTarget
 *                             or container.renderLocation
 */
export function insertWrapper(wrapper, anchor) {
  if (CONTAINER_TAGS.has(anchor.tagName)) {
    anchor.appendChild(wrapper);

    return;
  }

  const parent = anchor.parentNode;

  if (!parent) {
    document.body.appendChild(wrapper);

    return;
  }

  parent.insertBefore(wrapper, anchor.nextSibling);
}
